import isNull from 'lodash/isNull';
import Backbone from 'backbone';
import moment from 'moment';

import allUsersStore from 'zoomforth_zf/appglobals/all-users.js';
import userStore from 'zoomforth_zf/appglobals/user.js';
import pagesStore from 'zoomforth_zf/appglobals/pages.js';
import { displayBestErrorAlertForXhrFail } from 'zoomforth_tools/modern_helpers.js';

import { triggerFirebaseEvent } from 'zoomforth_tools/firebase_events.js';

const Route = Backbone.Model.extend({

  urlRoot: '/api/routes',

  defaults: {
    resource_type: 'page',

    // Analytics data which gets populated from the analytics API
    visitCount: null,
    lastVisitTimestamp: null,

    ask_for_name: false,
    ask_for_email: false
  },

  initialize: function(attrs, options) {
    this.on('error', function(model, xhr) {
      displayBestErrorAlertForXhrFail(xhr);
    });
  },

  parse: function(response) {
    // Be sure we always have moment time obj
    response.created_at = moment(response.created_at);
    return response;
  },

  getName() {
    return this.get('name');
  },

  getPage() {
    return pagesStore.get().get(this.get('resource_id'));
  },

  getNameOrUrl() {
    return this.getName() || this.getFullUrl();
  },

  getFullUrl() {
    return this.get('url');
  },

  getCreatedBy() {
    let createdBy = 'Unknown';
    let createdByUser = null;
    if (this.get('owner_id')) {
      createdByUser = allUsersStore.get().get(this.get('owner_id'));
    }
    if (createdByUser) {
      createdBy = createdByUser.get('email');
    }
    return createdBy;
  },

  getCreatedAt() {
    return this.get('created_at');
  },

  getLastActiveAt() {
    return this.get('lastVisitTimestamp');
  },

  getVisitCount() {
    return this.get('visitCount');
  },

  toJSON: function() {
    var obj = Route.__super__.toJSON.call(this);
    // Drop visitCount so we don't try to persist it to the server
    obj.created_at = obj.created_at ? obj.created_at.format() : null; // Serialize to ISO
    delete obj.visitCount;
    delete obj.lastVisitTimestamp;
    return obj;
  },

  
  destroy() {
    const isNew = this.isNew();

    return Route.__super__.destroy.apply(this, arguments)

      .done(()=> {
        if (!isNew) {
          triggerFirebaseEvent('routes-collection-change', {});
        }
      });      
  },

  save() {

    const isNew = this.isNew();

    return Route.__super__.save.apply(this, arguments)

      .done(()=> {
        if (isNew) {
          triggerFirebaseEvent('routes-collection-change', {});
        }
      });
  }

}, {

  getSortableIdentifier(route) {
    const name = route.getName();
    const pathname = route.get('route_path');
    return ((name && name.toLowerCase()) || '') + pathname;
  },

  getSortableCreatedBy(route) {
    return route.getCreatedBy();
  },

  getSortableCreatedAt(route) {
    return route.getCreatedAt();
  },

  getSortableLastActiveAt(route) {
    return route.getLastActiveAt();
  },
  
  getSortableVisitCount(route) {
    return route.getVisitCount();
  }

});

  
export default Route;
